
// import '@exactsciences/ph-web-components/dist/index';
// import { initConfig, localizationConfig } from '@helix-design-system/components/dist/components/localization-provider/localization-provider.js';
// initConfig(new Map([
//     ['es', Promise.all([
//         import(`/node_modules/@exactsciences/ph-web-components/dist/generated/locales/es.js`),
//         import(`/node_modules/@helix-design-system/components/dist/generated/locales/es.js`),
//     ])],
// ]));
// initConfig(new Map([
//     ['es', import(`/node_modules/@helix-design-system/components/dist/generated/locales/es.js`)],
// ]));
// console.log('Initial locale: ', localizationConfig.getLocale());
// localizationConfig.setLocale('es').then(() => {
//     console.log('New locale: ', localizationConfig.getLocale());
// });

window.addEventListener('DOMContentLoaded', async () => {
    try {

        if (isIOS14()) {
            alert("This page cannot load in your current browser. You can try updating your browser or use a different one.")
        }

        await import('../public/styles.css');
        await import('@exactsciences/ph-web-components/dist/components/header/ESHeader.js');
        await import('@exactsciences/ph-web-components/dist/components/footer/ESFooter.js');
        await import('@exactsciences/ph-web-components/dist/components/footer_v2/ESFooter-v2.js');
        await import('@helix-design-system/components/dist/components/accordion/index.js');
        await import('@helix-design-system/components/dist/components/alert/index.js');
        await import('@helix-design-system/components/dist/components/badge/index.js');
        await import('@helix-design-system/components/dist/components/button/index.js');
        await import('@helix-design-system/components/dist/components/card/index.js');
        await import('@helix-design-system/components/dist/components/carousel/index.js');
        await import('@helix-design-system/components/dist/components/checkbox/index.js');
        await import('@helix-design-system/components/dist/components/date-picker/index.js');
        await import('@helix-design-system/components/dist/components/divider/index.js');
        await import('@helix-design-system/components/dist/components/error-mapping/index.js');
        await import('@helix-design-system/components/dist/components/icon/index.js');
        await import('@helix-design-system/components/dist/components/icon-special/index.js');
        await import('@helix-design-system/components/dist/components/menu/index.js');
        await import('@helix-design-system/components/dist/components/notification-bar/index.js');
        await import('@helix-design-system/components/dist/components/one-time-code/index.js');
        await import('@helix-design-system/components/dist/components/password/index.js');
        await import('@helix-design-system/components/dist/components/phone/index.js');
        await import('@helix-design-system/components/dist/components/radio-group/index.js');
        await import('@helix-design-system/components/dist/components/select/index.js');
        await import('@helix-design-system/components/dist/components/spinner/index.js');
        await import('@helix-design-system/components/dist/components/tab-group/index.js');
        await import('@helix-design-system/components/dist/components/tag/index.js');
        await import('@helix-design-system/components/dist/components/text-field/index.js');
        await import('@helix-design-system/components/dist/components/textarea/index.js');
        await import('@helix-design-system/components/dist/components/toggle/index.js');
        await import('@helix-design-system/components/dist/components/toggletip/index.js');
        await import('@helix-design-system/components/dist/components/video-overlay/index.js');

        await import('./bootstrap');
    } catch (error) {
        alert("This page cannot load in your current browser. You can try updating your browser or use a different one.")
    }
});

function isIOS14() {
    const userAgent = navigator.userAgent;
    const match = userAgent.match(/OS (\d+)_\d+/); // Matches iOS version

    const isIOSDevice = userAgent.includes("iPhone") || userAgent.includes("iPad") ||
        (userAgent.includes("Macintosh") && 'ontouchend' in document);

    if (isIOSDevice) {
        // Check if the version is 14.7
        // log in page works on IOS 14.7
        if (match.toString() === 'OS 14_7,14') {
            return false;
        }

        const majorVersion = match ? parseInt(match[1], 10) : null;
        return majorVersion === 14;
    }
    return false;
}